<template>
  <component
    :is="modal.instance"
    v-for="(modal, idx) in modals"
    :key="modal.id"
    v-bind="modal.props"
    :hidden="idx !== modals.length - 1"
    v-on="modal.events"
  />
</template>

<script setup lang="ts">
import useModal from '@/services/useModal';

const { modals } = useModal();
</script>
